export const SWITCH_USER_FORM_FIELDS = {
    badgeNumber: 'badgeNumber',
    noBadge: 'noBadge',
    author: 'author',
}
